import { useInfiniteQuery } from "@tanstack/react-query";
import { api, unwrap } from "../api.ts";
import { Button, Card, PageHeader, Spinner } from "../components/ui.tsx";

export function AuditPage() {
  const q = useInfiniteQuery({
    queryKey: ["audit"],
    initialPageParam: undefined as number | undefined,
    queryFn: ({ pageParam }) => unwrap(api.admin.audit.$get({ query: { limit: "50", ...(pageParam ? { before: String(pageParam) } : {}) } })),
    getNextPageParam: (p) => p.next ?? undefined,
  });
  const rows = q.data?.pages.flatMap((p) => p.rows) ?? [];
  return (
    <>
      <PageHeader title="Audit log" description="Every sign-in and admin change, newest first." />
      <Card className="overflow-x-auto">
        {q.isPending ? (
          <div className="grid place-items-center py-16"><Spinner /></div>
        ) : (
          <table className="w-full min-w-[640px] text-sm">
            <thead>
              <tr className="border-b border-[var(--line)] text-left text-[11px] uppercase tracking-[0.08em] whitespace-nowrap text-[var(--muted)]">
                <th className="px-4 py-3 font-medium">When</th>
                <th className="px-4 py-3 font-medium">Who</th>
                <th className="px-4 py-3 font-medium">Action</th>
                <th className="px-4 py-3 font-medium">Details</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-b border-[var(--line)] align-top last:border-0">
                  <td className="whitespace-nowrap px-4 py-3 text-[var(--muted)]">{new Date(r.at).toLocaleString()}</td>
                  <td className="px-4 py-3">{r.actorEmail ?? "system"}</td>
                  <td className="px-4 py-3 font-mono text-xs">{r.action}</td>
                  <td className="w-full max-w-0 truncate px-4 py-3 font-mono text-xs text-[var(--muted)]" title={JSON.stringify(r.details)}>
                    {Object.keys(r.details).length ? JSON.stringify(r.details) : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
      {q.hasNextPage && (
        <div className="mt-4 flex justify-center">
          <Button onClick={() => q.fetchNextPage()} disabled={q.isFetchingNextPage}>Load more</Button>
        </div>
      )}
    </>
  );
}
